export default __webpack_public_path__ + "static/media/som_moto.70d813bf.mp3";